export const environment: { production: boolean; label: string; apiBaseUrl: string } = {
  production: false,
  label: 'DEV',
  apiBaseUrl: 'https://dev-api.wasel-crm.com',
};
